import { render, staticRenderFns } from "./onebox-list-package.vue?vue&type=template&id=d4490fd8&scoped=true&"
import script from "./onebox-list-package.vue?vue&type=script&lang=js&"
export * from "./onebox-list-package.vue?vue&type=script&lang=js&"
import style0 from "./onebox-list-package.vue?vue&type=style&index=0&id=d4490fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4490fd8",
  null
  
)

export default component.exports